import React, { useContext } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import classNames from "classnames";
import { isActive } from "./utils";
import { useMediaQuery } from "react-responsive";
import { AsideContext } from "./Aside";

type NavLinkProps = {
  to: string[];
  children: React.ReactNode;
  exact?: boolean;
  queryString?: string;
  show: boolean | undefined | null; // Should this navigation item be shown?
  title?: string;
  onClick?: any;
  metricsCategory?: string; // if filled, the click will be logged to ElasticSearch with this category
  metricsSubCategory?: string; // if filled, the click will be logged to ElasticSearch with this subcategory
};

type ConditionalWrapperProps = {
  condition: boolean;
  wrapper: (children: any) => {};
  children: any;
};

const popperConfig = {
  modifiers: [
    {
      name: "offset",
      options: {
        offset: [0, 3],
      },
    },
  ],
};

const ConditionalWrapper = ({ condition, wrapper, children }: ConditionalWrapperProps) =>
  condition ? wrapper(children) : children;

const NavLink = ({
  to,
  children,
  exact,
  queryString,
  title,
  show,
  onClick,
  metricsCategory,
  metricsSubCategory,
}: NavLinkProps) => {
  const isLargeScreen = useMediaQuery({ query: "(min-width: 1401px) and (hover: hover)" });
  const { collapsed } = useContext(AsideContext);
  if (!show) return null;
  const className = classNames(
    { active: isActive(to, exact, queryString) },
    metricsCategory ? "js-log-metric" : "" // this CSS class make the onclick log to ElasticSearch
  );
  return (
    <ConditionalWrapper
      condition={!!title && collapsed && isLargeScreen}
      wrapper={(children) => (
        <OverlayTrigger
          placement="right"
          popperConfig={popperConfig}
          overlay={<Tooltip id={`aside-tooltip`}>{title}</Tooltip>}
        >
          {children}
        </OverlayTrigger>
      )}
    >
      <li>
        <a
          onClick={onClick}
          href={to[0]}
          className={className}
          data-metrics_category={metricsCategory}
          data-metrics_sub_category={metricsSubCategory}
        >
          {children}
        </a>
      </li>
    </ConditionalWrapper>
  );
};

export default NavLink;
